import { Phone } from "lucide-react";
import { BUSINESS } from "@/lib/config";

export default function FloatingCall() {
  return (
    <a
      href={`tel:${BUSINESS.phone1Tel}`}
      className="fixed bottom-20 right-4 sm:bottom-24 sm:right-6 z-40 bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-full p-4 shadow-xl shadow-orange-900/20 group"
      aria-label="Hemen Ara"
      data-testid="floating-call-button"
    >
      <Phone className="w-6 h-6" />
      <span className="absolute inset-0 rounded-full bg-[#FF4500] -z-10 animate-ping opacity-40"></span>
      <span className="hidden sm:block absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-zinc-950 text-white text-sm font-bold px-3 py-2 rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
        {BUSINESS.phone1}
      </span>
    </a>
  );
}
